'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TransmuteCollection = require('./TransmuteCollection');

var jsToKeySeq = function jsToKeySeq(subject) {
  return (0, _immutable.Seq)(subject).keySeq();
};

_TransmuteCollection.keySeq.implement(Array, jsToKeySeq);
_TransmuteCollection.keySeq.implementInherited(_immutable.Iterable, function (subject) {
  return subject.keySeq();
});
_TransmuteCollection.keySeq.implement(Object, jsToKeySeq);

exports.default = _TransmuteCollection.keySeq;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/internal/_keySeq.js
// module id = 362
// module chunks = 0 1